import LegalLayout from './landing/LegalLayout';

function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy">
      <section>
        <h2>Introduction</h2>
        <p>
          Welcome to our Privacy Policy. Your privacy is critically important to
          us. This Privacy Policy document contains types of information that is
          collected and recorded by our service and how we use it.
        </p>
      </section>

      <section>
        <h2>Information We Collect</h2>
        <ul>
          <li>Chat messages and interactions with our AI system</li>
          <li>Basic usage data to improve our service</li>
          <li>Technical information necessary for the service to function</li>
        </ul>
      </section>

      <section>
        <h2>How We Use Your Information</h2>
        <p>We use the collected information for:</p>
        <ul>
          <li>Providing and maintaining our Service</li>
          <li>Improving and personalizing user experience</li>
          <li>Analyzing usage patterns to enhance our AI system</li>
          <li>Communicating with you about service-related matters</li>
        </ul>
      </section>

      <section>
        <h2>Data Protection</h2>
        <p>
          We implement a variety of security measures to maintain the safety of
          your personal information. Your data is contained behind secured
          networks and is only accessible by a limited number of persons who
          have special access rights.
        </p>
      </section>

      <section>
        <h2>Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal data</li>
          <li>Correct inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Object to our processing of your data</li>
          <li>Data portability</li>
        </ul>
      </section>

      <section>
        <h2>Contact Information</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us
          at: <a href="mailto:privacy@efsoft.com">privacy@efsoft.com</a>
        </p>
      </section>

      <div className="legal-callout">
        <p>
          By using our service, you consent to our Privacy Policy and agree to
          its terms. If you have additional questions or require more
          information about our Privacy Policy, do not hesitate to contact us.
        </p>
      </div>
    </LegalLayout>
  );
}

export default PrivacyPolicy;
